import React, { Component } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import { loginUserAction } from 'actions/authenticationActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import { isSupported } from "firebase/messaging";
import { getFirebaseToken } from "utils/firebase";

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  Input,
  InputGroupText,
  InputGroup
} from "reactstrap";

class AdminLoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false,
      pushNotificationToken: ''
    }    
  }
  componentWillMount() {
    document.title = 'Login';
  }

  async componentDidMount() {
    console.log("Login-> componentDidMount-> Before isSupported check");
    const isBrowserFirebaseMessagingSupport = await isSupported();
    console.log("Login-> componentDidMount-> After isSupported check");

    if (isBrowserFirebaseMessagingSupport === true) {        
      getFirebaseToken()
          .then((firebaseToken) => {
              console.log('Login-> componentDidMount-> Firebase token: ', firebaseToken);
              this.setState({pushNotificationToken: firebaseToken});
          })
          .catch((err) => console.error('Login-> componentDidMount-> An error occured while retrieving firebase token. ', err))
    }
    else
      console.log('Login-> componentDidMount-> Firebase messaging is not supported');            
  }

  componentWillUnmount() {
    if(this.props.response.login.response !== 'undefined')
      delete this.props.response.login.response;
  }

  render() {
    let isSuccess, message;

    if (this.props.response.login.hasOwnProperty('response')) {
      if(this.props.response.login.response &&
          this.props.response.login.response.hasOwnProperty('error')){
        isSuccess = false;
        message = 'Incorrect username or password!';
      }
      else if(this.props.response.login.response &&
        this.props.response.login.response.hasOwnProperty('accessToken'))
        isSuccess = true;            
    }

    if (isSuccess) {
      this.props.response.login.userToken = this.props.response.login.response.accessToken;
      this.props.response.login.redirectAfterSignInTo ? 
      this.props.navigate(this.props.response.login.redirectAfterSignInTo)
      : this.props.navigate('/liquidlove/requests');
    }
    return (      
      <Formik
            initialValues={{
                username: '',
                password: ''
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string()
                    .required('username is required'),
              password: Yup.string()                
                    .required('password is required'),
            })}
        onSubmit={fields => {
            let username = fields.username;            
            let password = fields.password;
            let pushNotificationToken = this.state.pushNotificationToken;    
            
            const data = {
              username, password, pushNotificationToken
            }
            this.props.dispatch(loginUserAction(data));
        }  
      }
        render={({ errors, status, touched }) => (                    
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Liquid Love Login                            
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                    <div style={{color: "red"}}>{message}</div><br/>
                      <Form>
                      <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Username
                      </InputGroupText>
                    <Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                    <ErrorMessage name="username" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.lastFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Password
                      </InputGroupText>
                    <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                    <ErrorMessage name="password" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <div className="col text-center">
                    <button type="submit" size="lg" outline className="btn btn-primary">Login</button>
                  </div>
                      </Form>
                      <div className="col text-center">
                        <Link className="nav-link" to={'/liquidlove/forgot-pwd'}>Forgot Password</Link>
                      </div>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <AdminLoginPage navigate={navigate} {...props} />
});